var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from 'react';
import createPermissionFeatureWithoutStoreHook from './CreatePermissionFeatureWithoutStoreHook';
export default function createCustomResolverPermissionFeatureHook(permissionEnum, useCustomResolverHook) {
    var usePermissionFeatureWithoutStore = createPermissionFeatureWithoutStoreHook()(permissionEnum);
    return function () {
        var permissionFeatureWithoutStore = usePermissionFeatureWithoutStore();
        var getActiveId = useCustomResolverHook().getActiveId;
        var permissionFeatureHookFunctions = useMemo(function () {
            return __assign(__assign({}, permissionFeatureWithoutStore), { hasOnActiveItemPermission: function (permission) {
                    var activeId = getActiveId();
                    if (!activeId) {
                        return false;
                    }
                    return permissionFeatureWithoutStore.hasPermission(activeId, permission);
                }, hasOnActiveItemPermissions: function (permissions) {
                    var activeId = getActiveId();
                    if (!activeId) {
                        return false;
                    }
                    return permissionFeatureWithoutStore.hasPermissions(activeId, permissions);
                } });
        }, [permissionFeatureWithoutStore, getActiveId]);
        return permissionFeatureHookFunctions;
    };
}
//# sourceMappingURL=CreateCustomResolverPermissionFeatureHook.js.map